import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useConfirmAccountMutation } from 'store/services/segmentsApi';
import { useParseURLQueryParams } from 'utils';

export default function ConfirmPage() {
  const { query } = useParseURLQueryParams();
  const history = useHistory();

  const [confirmAccount, { isSuccess }] = useConfirmAccountMutation();

  useEffect(() => {
    if (!!!query.token || isSuccess) {
      history.replace('/');
      return;
    }
    confirmAccount({ token: query.token });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.token, isSuccess]);

  return (
    <>
      <div>Account verification...</div>
    </>
  );
}
